import { Box } from '@mui/material'
import React from 'react'
import Headeer from '../../components/Headeer'
import LineChart from '../../components/LineChart'

export default function Line() {
  return (
    <Box marginLeft={2} marginRight={2}>
      <Headeer title="Line Chart"/>
      <Box height="75vh">
      <LineChart/>

      </Box>
    </Box>
  )
}
